document.addEventListener('DOMContentLoaded', function () {
  Object.keys(window.storeLocatorData || {}).forEach(initStoreLocator);
});

function initStoreLocator(sectionId) {
  var data = window.storeLocatorData[sectionId];
  if (!data || !data.apiKey) return;
  var callbackName = 'initMap_' + sectionId.replace(/[^a-zA-Z0-9]/g, '_');
  window[callbackName] = function () { buildMap(sectionId, data); };
  var script = document.createElement('script');
  script.src = 'https://maps.googleapis.com/maps/api/js?key=' + data.apiKey + '&callback=' + callbackName;
  script.async = true;
  document.head.appendChild(script);
}

function buildMap(sectionId, data) {
  var mapEl = document.getElementById('store-locator-map-' + sectionId);
  var listEl = document.getElementById('store-locator-list-' + sectionId);
  var map = new google.maps.Map(mapEl, { zoom: data.defaultZoom || 11, center: { lat: 33.7490, lng: -84.3880 } });
  var geocoder = new google.maps.Geocoder();
  var bounds = new google.maps.LatLngBounds();
  var cacheKey = 'storeLocatorGeocode_' + sectionId;
  var cache = JSON.parse(localStorage.getItem(cacheKey) || '{}');
  var markers = [];
  var openInfoWindow = null;
  var searchInput = document.getElementById('store-locator-search-' + sectionId);
  var searchBtn = document.getElementById('store-locator-search-btn-' + sectionId);

function doSearch() {
  var query = searchInput.value.trim();
  if (!query) return;
  geocoder.geocode({ address: query }, function (results, status) {
    if (status === 'OK' && results[0]) {
      map.panTo(results[0].geometry.location);
      map.setZoom(11);
    }
  });
}

if (searchBtn) searchBtn.addEventListener('click', doSearch);
if (searchInput) searchInput.addEventListener('keydown', function (e) {
  if (e.key === 'Enter') doSearch();
});

  data.stores.forEach(function (store) {
    if (cache[store.address]) {
      placeMarker(store, cache[store.address]);
    } else {
      geocoder.geocode({ address: store.address }, function (results, status) {
        if (status === 'OK' && results[0]) {
          var loc = results[0].geometry.location;
          var coords = { lat: loc.lat(), lng: loc.lng() };
          cache[store.address] = coords;
          localStorage.setItem(cacheKey, JSON.stringify(cache));
          placeMarker(store, coords);
        } else {
          console.warn('Geocode failed for', store.address, status);
        }
      });
    }
  });

  function placeMarker(store, coords) {
  var marker = new google.maps.Marker({ position: coords, map: map, title: store.name });

  var content = '<div class="store-locator__info">';
  content += '<strong>' + store.name + '</strong>';
  content += '<p class="store-locator__info-address">' + store.address + '</p>';

  if (store.phone) {
    content += '<p class="store-locator__info-phone"><a href="tel:' + store.phone + '">' + store.phone + '</a></p>';
  }

  if (store.hours) {
    content += '<p class="store-locator__info-hours">' + store.hours.replace(/\n/g, '<br>') + '</p>';
  }

  var directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(store.address);
  content += '<a class="store-locator__directions" href="' + directionsUrl + '" target="_blank">Get directions</a>';

  content += '</div>';

  var infoWindow = new google.maps.InfoWindow({ content: content });
  var infoWindow = new google.maps.InfoWindow({ content: content, maxWidth: 400 });
  marker.addListener('click', function () {
  if (openInfoWindow) { openInfoWindow.close(); }
  infoWindow.open(map, marker);
  openInfoWindow = infoWindow;
  var allItems = listEl.querySelectorAll('.store-locator__list-item');
  allItems.forEach(function (el) { el.classList.remove('is-active'); });
  var matchingItem = listEl.querySelector('[data-address="' + store.address + '"]');
  if (matchingItem) {
    matchingItem.classList.add('is-active');
    matchingItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
});

  markers.push({ marker: marker, store: store });
  bounds.extend(coords);
  map.fitBounds(bounds);
  renderListItem(store, marker, map);
}

  function renderListItem(store, marker, map) {
    var item = document.createElement('div');
    item.className = 'store-locator__list-item';
    item.setAttribute('data-address', store.address);

    var pills = '';
    if (store.products && store.products.length) {
      pills = '<div class="store-locator__pills">' +
        store.products.map(function (p) {
          return '<span class="store-locator__pill">' + p.title + '</span>';
        }).join('') +
      '</div>';
    }

    item.innerHTML = '<strong>' + store.name + '</strong><p>' + store.address + '</p>' + pills;

    item.addEventListener('click', function () {
      document.querySelectorAll('#store-locator-list-' + sectionId + ' .store-locator__list-item')
        .forEach(function (el) { el.classList.remove('is-active'); });
      item.classList.add('is-active');
      map.panTo(marker.getPosition());
      map.setZoom(15);
      google.maps.event.trigger(marker, 'click');
    });

    listEl.appendChild(item);
  }

  var filterSelect = document.querySelector('#store-product-filter-' + sectionId);
  if (filterSelect) {
    filterSelect.addEventListener('change', function () {
      var handle = filterSelect.value;
      markers.forEach(function (entry) {
        entry.marker.setVisible(!handle || entry.store.products.some(function (p) { return p.handle === handle; }));
      });
    });
  }
}